<section class="pricing">
  <h2 class="pricing__title">{{ 'tariff_plan' | translate }}</h2>

  <div class="pricing-card-container">
    <div class="card">
      @for (tariff of tariffs; track tariff.id) {
        <h3 class="card__title">{{ tariff.title }}</h3>
        <span class="card__usd">${{ tariff.price }}/{{ 'mo' | translate }}</span>
        <p class="card__price">{{ pricingService.getPriceInUAH(tariff.price) }}
          <span>{{ 'uah_month' | translate }}</span></p>
        <a [title]="'days_for_the_test' | translate" [href]="environment.login_url">
          <div class="card__badge">+ 5 {{ 'days_for_the_test' | translate }}</div>
        </a>
        <p *ngIf="tariff.price" class="card__description">{{ 'unique_solutions' | translate }}</p>
        <div class="tariff-additional-box">
          @for (additional of tariff.additional; track additional.name) {
            <div class="tariff-additional">
              @if (additional.included) {
                <app-icon>check</app-icon>
              }
              <span >{{ additional.name }}</span>

            </div>
          }
        </div>
      }
    </div>
  </div>
</section>
